<template>
  <div class="my-footer">
    <div class="wrap container">
      <div class="left">
        <!-- <img :src="require(`../../assets/${assetsConfig.homePage.footer.logo}`)" class="logo"/> -->
        <svg class="logo" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 750.1 205.3" style="enable-background:new 0 0 750.1 205.3;" xml:space="preserve">
          <g>
            <path class="st0" d="M673.6,200.2h-13.5l4.3-16h13.5L673.6,200.2z M663.2,136.5h11.4v-2.1H690v2.1h11.4v5.1H690v1.7h9.6v5.2H690
              v1.7h12.2v5.3H690v2.4h-15.4v-2.4h-12.2v-5.3h12.2v-1.7h-9.7v-5.2h9.7v-1.7h-11.4L663.2,136.5L663.2,136.5z M664.7,175.9H726v-3.1
              h-56.7v-4H726V166h-61.3v-6h76.6v21.8h-76.6V175.9z M681.7,184.2h13.5l-3,11.2h35.9v4.8h-50.6L681.7,184.2z M712.1,192.6l-0.9-3.6
              h-13.5l1.2-4.8h24.4l2.2,8.4H712.1z M704.5,136.5H716v-2.1h15.3v2.1h11.6v5.1h-11.6v1.7h9.7v5.2h-9.7v1.7h12.3v5.3h-12.3v2.4H716
              v-2.4h-12.3v-5.3H716v-1.7h-9.6v-5.2h9.6v-1.7h-11.4L704.5,136.5L704.5,136.5z M732.3,200.2l-4.3-16h13.5l4.3,16
              C745.8,200.2,732.3,200.2,732.3,200.2z"/>
          </g>
          <path class="st0" d="M250.2,160h14.1l4.6-4.6h-13V149h19.6l4-3.9h-28.1v-6.5h34.7l4.4-4.2H309l-4.3,4.2h29.8v6.5h-36.4l-4,3.9h36
            v6.4h-42.5l-4.7,4.6h53v6.4h-9.6l9.6,7.5h-18.7l-9.6-7.5h-31.1l-7.6,7.5h-18.6l7.5-7.5h-7.5L250.2,160L250.2,160z M281.5,188
            l-16.3,12.2h-15l16.3-12.2H281.5z M253.5,175.8h15l12.9,10.4h-15L253.5,175.8z M278,194.9v-2.4h9.8V168h12.9v32.1h-0.9h-12h-2
            M305.5,186.2l11.9-10.4h15l-12,10.4H305.5z M335.8,200.2h-15L306,188h15L335.8,200.2z"/>
          <path class="st0" d="M386.5,200.3v-7.7l7.5,0.1v-35.1h-7.5v-6.9h7.5v-16.4h13.4v16.4h8.2v6.9h-8.2v35h8.2v7.7H386.5z M418.4,192.6
            h53.8v7.6h-53.8V192.6z M432.6,187.7h-12.5v-52.5h12.5v6v-6h37.6v52.5h-12.6 M432.6,157.5h25v-14.9h-25V157.5z M432.6,178.2h25V165
            h-25V178.2z"/>
          <path class="st0" d="M522.8,167.9l10.1-11.3h-10.1v-5.7h15.1l6.7-7.6h-7.8l-2.4,3.5h-11.7l8.3-12.4h11.8l-2.2,3.2h25.2v5.7h-9.5
            l-6.7,7.6h19.1v5.7h-9l9.9,11.3h-11.7l-10-11.3h-3.5l-10.1,11.3C534.3,167.9,522.8,167.9,522.8,167.9z M540.3,200.2h-13.5V170h13.5
            l-0.2,0.8l0.2-0.7h51.2V170h13v30.2h-13 M540.3,176.5v5h51.2v-5H540.3z M540.3,187.2v5h51.2v-5H540.3z M582.2,167.9H571V136h11.2
            v3.9V136h26.3v31.9h-11.3 M582.2,142.5v18.6h15v-18.6H582.2z"/>
          <polygon class="st0" points="575.6,23.3 549.7,23.3 502.4,105.2 528.2,105.2 "/>
          <path class="st0" d="M282.4,44.6h-38.5V23.3h104.6v21.3h-40.2v60.6h-25.8V44.6H282.4z"/>
          <path class="st0" d="M369.7,105.2V23.3h25.8v81.9L369.7,105.2L369.7,105.2z"/>
          <path class="st0" d="M455.3,44.6h-38.5V23.3h104.7l-12.3,21.3h-28v60.6h-25.8V44.6H455.3z"/>
          <rect x="644.2" y="53.5" class="st0" width="25.8" height="51.6"/>
          <path class="st0" d="M431.8,72.4"/>
          <polygon class="st0" points="549.8,23.3 575.7,23.3 622.9,105.2 597.1,105.2 562.7,45.6 "/>
          <polygon class="st0" points="549.7,105.2 575.7,105.2 562.7,82.7 "/>
          <path class="st0" d="M724.3,23.3v61l-45.5-59.2c1.1,2.7,1.7,5.7,1.7,8.8c0,6.1-2.4,11.7-6.2,15.8l44.2,55.4h31.6V23.2L724.3,23.3
            L724.3,23.3z"/>
          <circle class="st0" cx="657.2" cy="32.2" r="12.9"/>
          <g>
            <path class="st0" d="M175.1,64.7c2.3,0,4.2,1.9,4.2,4.2v22.7l0,0v76.8c14.5-17.5,23.2-40,23.2-64.5c0-23.8-8.3-45.8-22.1-63.1
              c-5.7,6.2-13.9,10.1-23,10.1c-17.2,0-31.1-13.9-31.1-31.1c0-4.7,1.1-9.2,3-13.3c-8.9-2.6-18.3-3.9-28.1-3.9C45.3,2.7,0,48,0,103.9
              c0,28.2,11.6,53.7,30.2,72.1L70.7,64.7L175.1,64.7z"/>
            <path class="st0" d="M61.6,197.2c12.2,5.2,25.6,8.1,39.7,8.1c14.3,0,27.8-3,40.1-8.3v-35.6h-31.5v-23.6h31.5V104H95.6L61.6,197.2z"/>
          </g>
          <circle class="st0" cx="157.5" cy="19.9" r="19.9"/>
        </svg>
        <!-- <Button class="white-btn conseil" type="primary" ghost @click="showConsultationModal">立即咨询</Button> -->
        <p class="email">邮箱：contactus@titan-os.com</p>
        <p class="tel">电话：0510-85739966</p>
        <p class="addr">
          江苏省无锡市经济开发区金融一街昌兴国际金融大厦7层（总部）
        </p>
        <p class="addr">
          广东省深圳市南山区深圳湾科技生态园9栋A座1502（研发中心）
        </p>
        <p class="addr">
          湖北省武汉市武昌区公正路216号平安金融科技大厦2712（研发中心）
        </p>
        <p class="addr">
          北京市海淀区德胜门西大街15号（办事处）
        </p>
        <p class="wx">
          <img src="@/assets/footer_wx.png" alt="" />
          <span>官方微信公众号</span>
        </p>
      </div>
      <div class="right">
        <ul class="list">
          <li class="title">TitanOS</li>
          <li class="item1"><router-link to="/#collapse-card">概述</router-link></li>
          <li class="item1"><router-link to="/#product-module">模块</router-link></li>
          <li class="item1"><router-link to="/#product-value">价值</router-link></li>
          <li class="item1"><router-link to="/#product-super">优势</router-link></li>
          <li class="item1"><router-link to="/#product-AIO">形态</router-link></li>
          <li class="item1"><router-link to="/#product-core">内核</router-link></li>
        </ul>
        <ul class="list">
          <li class="title">行业案例</li>
          <li class="item"><router-link to="/resolution/power">电力行业</router-link></li>
          <li class="item"><router-link to="/resolution/teach">教育行业</router-link></li>
          <li class="item"><router-link to="/resolution/energy">能源行业</router-link></li>
          <li class="item"><router-link to="/resolution/video">交通行业</router-link></li>
          <li class="item"><router-link to="/resolution/traffic">制造行业</router-link></li>
          <li class="item"><router-link to="/resolution/video">音视频分析</router-link></li>
        </ul>
        <ul class="list">
          <li class="title">关于我们</li>
          <li><router-link to="/aboutus/#about-us-1">公司简介</router-link></li>
          <li><router-link to="/aboutus/#about-us-2">关于创始人</router-link></li>
          <li><router-link to="/aboutus/#about-us-3">战略布局</router-link></li>
        </ul>
      </div>
      <div class="clear-fix"></div>
      <p class="tips">
        {{icp.name}}
        <a href="https://beian.miit.gov.cn">苏ICP备2021005787号</a>
      </p>
      <div v-html="icp.text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-footer',
  data() {
    return {
      assetsConfig: ASSETS_CONFIG
    }
  },
  computed: {
    icp() {
      // console.log(window.location.hostname.includes('whileflow'))
      if (window.location.hostname.includes('whileflow')) {
        return {
          number: 1,
          text: `<div style="width:300px;margin:0 auto; padding:20px 0; text-align: center;">
  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102001160" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
    <img alt="泰坦智慧" title="titanos" src="${require('../../assets/' + ASSETS_CONFIG.homePage.footer.icp)}" style="float:left;" />
    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏公网安备 32021102001160号</p>
  </a>
</div>`,
          name: `© 2017-${new Date().getFullYear()} 江苏泰坦智慧科技有限公司 版权所有`
        }
      } else {
        return {
          number: 2,
          text: `<div style="width:300px;margin:0 auto; padding:20px 0; text-align: center;">
  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102001161" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
    <img alt="泰坦智慧" title="titanos" src="${require('../../assets/' + ASSETS_CONFIG.homePage.footer.icp)}" style="float:left;" />
    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏公网安备 32021102001161号</p>
  </a>
</div>`,
          name: `© 2017-${new Date().getFullYear()} 江苏泰坦智慧科技有限公司 版权所有`
        }
      }
    }
  },
  methods: {
    showConsultationModal() {
      this.$emit('on-show', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.st0
  fill #FFFFFF
.my-footer
  width 100%
  min-width 1200px
  background #161a25
  .wrap
    overflow hidden
    .left
      float left
      position relative
      padding-left 10px
      width 580px
      .logo
        width 160px
        height 44px
        margin-top 70px
        opacity .7
        margin 70px 200px 10px 0
      .white-btn
        border-color #fff
        color #fff
        width 160px
        text-align center
      p.email
        margin-top 39px
        color #babbbe
      p.addr
        margin 10px 74px 0 0
        color #babbbe
      p.wx
        width 107px
        text-align center
        position absolute
        top 196px
        right 58px
        color #fff
        span
          opacity 0.7
        img
          width 107px
      p.tel
        margin 10px 74px 0 0
        color #babbbe
      &::after
        content ''
        display block
        background #5c5f67
        position absolute
        width 1px
        height 230px
        bottom -20px
        right 0
    .right
      float left
      padding 160px 0 0 58px
      width 620px
      .title
        font-size 14px
        color #fff
      .list
        overflow hidden
        display inline-block
        &:nth-child(1)
          width 150px
          margin-right 50px
        &:nth-child(2)
          width 250px
          margin-right 10px
        &:nth-child(3)
          width 90px
        li
          line-height 45px
          a
            display block
            color #babbbe
            padding-right 30px
          &.item1
            display inline-block
            width 38%
          &.item
            display inline-block
            width 36%
    .tips
      color #babbbe
      text-align center
      margin 68px 0 -10px
      a
       color #babbbe
</style>



// WEBPACK FOOTER //
// src/components/basic/MyFooter.vue